/* Welke berekende waarden de casepagina terugschrijft, en wanneer.
 *
 * Tot 29-09-2026 schreef de pagina ze bij elke keer openen weg. Daardoor was
 * "laatst gewijzigd" eigenlijk "laatst bekeken" (de trigger zet updated_at), en een
 * terugverdientijd met decimalen (2,4 jaar) liet het hele schrijven mislukken, want
 * payback_period is een integer. Nu: alleen als er iets anders uitkomt, en de
 * terugverdientijd afgerond. De lijst en de pagina rekenen zelf; deze kolommen zijn er
 * voor wie de tabel direct leest (de projectpagina leest net_investment).
 *
 * Relatieve imports (geen @/), zodat de toetsen dit bestand zonder bundel lezen. */

export interface Uitkomst {
  totalInvestment: number;
  eiaValue: number;
  netInvestment: number;
  totalRevenues: number;
  totalCashflow: number;
  roiYear1: number | null;
  roiBestCase: number | null;
  roiWorstCase: number | null;
  paybackPeriod: number | null;
}

export function opgeslagenWaarden(c: Uitkomst) {
  return {
    total_investment: c.totalInvestment,
    eia_value: c.eiaValue,
    net_investment: c.netInvestment,
    total_revenues: c.totalRevenues,
    total_cashflow: c.totalCashflow,
    roi_year1: c.roiYear1,
    roi_best_case: c.roiBestCase,
    roi_worst_case: c.roiWorstCase,
    /* de kolom is een integer: 2,4 jaar wordt 2 */
    payback_period: c.paybackPeriod === null ? null : Math.round(c.paybackPeriod),
  };
}

export type OpgeslagenWaarden = ReturnType<typeof opgeslagenWaarden>;

const gelijk = (a: unknown, b: unknown) => {
  if ((a === null || a === undefined) && (b === null || b === undefined)) return true;
  if (a === null || a === undefined || b === null || b === undefined) return false;
  return Math.abs(Number(a) - Number(b)) < 0.005;
};

/** Staat dit al zo in de rij? Dan hoeft er niets geschreven te worden. */
export function alOpgeslagen(rij: Record<string, unknown>, w: OpgeslagenWaarden): boolean {
  return (Object.keys(w) as (keyof OpgeslagenWaarden)[]).every((k) => gelijk(rij[k], w[k]));
}
